import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ReportsProductWisePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reports-product-wise',
  templateUrl: 'reports-product-wise.html',
})
export class ReportsProductWisePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ReportsProductWisePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/reports-product-wise/reports-product-wise.ts